import { BrowserRouter } from "react-router";

import { ErrorFallback } from "./ErrorFallback";

/**
 * Reports a failure that happens before the React tree mounts.
 *
 * Bootstrap reads the deployment config, and it runs ahead of every error
 * boundary, so a failure there would otherwise leave an empty page. This brings
 * its own router, which `ErrorFallback` needs.
 */
export function BootstrapErrorFallback() {
  return (
    <BrowserRouter>
      <ErrorFallback
        message="Unable to load the application configuration. If the problem persists, please contact Stacklet support."
        resetErrorBoundary={() => window.location.reload()}
        tryAgain
      />
    </BrowserRouter>
  );
}
